import React from "react";

export default function Footer() {
  return (
    <footer className="text-center mt-16 text-gray-500 text-sm p-4">
      &copy; {new Date().getFullYear()} Solarya. All rights reserved.
    </footer>
  );
}